import { h } from 'preact'
import { useSelector } from 'react-redux'
import translate from 'core/translate'

export default function NumberOfHits() {
    const { q: query, pagingFilteringContext } = useSelector(
        state => state.currentPage,
    )

    const state = useSelector(state => state.currentPage)

    const { totalItems } = pagingFilteringContext ?? {}

    if (!totalItems) return null

    return (
        query && (
            <div className="total-hits-wrapper">
                <span>
                    {translate('search.numberOfResultsFor', totalItems, query)}
                </span>
            </div>
        )
    )
}
